import { LobbyImage } from '@colonist/types';
import { UIMMatchmakingSearchingView } from './UIMMatchmakingSearchingView.ts';
import { MatchmakingMatchTypes } from '@colonist/game-base-types';
export class UIMMatchmakingSearchingCnKView extends UIMMatchmakingSearchingView {
    addTitle() {
        super.addTitle();
        this.setTimeElapsedCounter();
    }
    constructor(matchmakingController){
        const loadingText = {
            key: 'strings:homePage.matchmakingPopup.searchingForOpponents'
        };
        const title = {
            key: 'strings:homePage.matchmakingPopup.rankedCitiesAndKnights.title'
        };
        const imageSrc = LobbyImage.GameModeCnK;
        super(matchmakingController, title, imageSrc, loadingText, MatchmakingMatchTypes.RankedCitiesAndKnights4P);
    }
}
